import axios from 'axios';
import router from './router';
import qs from 'qs'
import ApexConfig from '@/apex-config.js'
import store from './store'

axios.defaults.baseURL = ApexConfig.apiIp;
// axios.defaults.baseURL = 'http://10.1.1.21:9005';
// axios.defaults.headers.common['Authorization'] = 'localStorage.apextoken';
axios.interceptors.request.use(function (config) {
    // debugger;
    if (localStorage.apextoken) { //判断token是否存在
        if (!config.data) {
            config.data = {};
        }
        config.data.apextoken = localStorage.apextoken;
    }
    if (localStorage.deviceId) {
        config.data.deviceId = localStorage.deviceId;
    }
    if (store.state && store.state.currentFunctionId) {
        config.data.currentFunctionId = store.state.currentFunctionId;
    }
    if (store.state) {
        if (store.state.currentFunctionId) {
            config.data.currentFunctionId = store.state.currentFunctionId;
        }
        if (store.state.language) {
            config.data.uiLanguage = store.state.language;
        }
    }
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    if (config.method === 'post') { // post请求时，处理数据

        config.data = qs.stringify({
            ...config.data //后台数据接收这块需要以表单形式提交数据，而axios中post默认的提交是json数据,所以这里选用qs模块来处理数据，也有其他处理方式，但个人觉得这个方式最简单好用
        })
        config.data = config.data.replace(/%5D%5B(.+?)%5D=/g, "%5D.$1=");
    }

    return config;
}, function (error) {
    loadinginstace.close()
    return Promise.reject(error);
})

function errorResponseHandler(error) {
    if (error.response.statusText == "Device Error") {
        router.push('/ErrorDevice')
        // store.commit('setMessageText', 'Device Error')
    } else {
        store.commit('setMessageText', 'The server is abnormal. Please try again later.')
    }

}

axios.interceptors.response.use(
    response => response,
    errorResponseHandler
);
// http request 拦截器
// axios.interceptors.request.use(
//     config => {
//         if (localStorage.apextoken) { //判断token是否存在
//             config.headers.Authorization = localStorage.apextoken;  //将token设置成请求头
//         }
//         return config;
//     },
//     err => {
//         return Promise.reject(err);
//     }
// );
// // http response 拦截器
// axios.interceptors.response.use(
//     response => {
//         if (response.data.errno === 999) {
//             router.replace('/');
//             console.log("token过期");
//         }
//         return response;
//     },
//     error => {
//         return Promise.reject(error);
//     }
// );
export default axios;
